import axios, {AxiosResponse} from 'axios'

// List Section
const sectionList = async ({params}) => {
  const response = await axios.get('/api/section/list', params)
  return response.data
}

// Create Or Update new Section
const sectionCreate = async ({data}) => {
  await axios.post('/api/section/store', data)
}

// Edit Section
const sectionEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/section/edit/${id}`)
  return response.data
}

// Delete Section
const sectionDelete = async (id: string) => {
  await axios.get(`/api/section/destroy/${id}`)
}

// List academicYear
const academicYearList = async ({params}) => {
  const response = await axios.get('/api/academic-year/list', params)
  return response.data
}

// Create Or Update new academicYear
const academicYearCreate = async ({data}) => {
  await axios.post('/api/academic-year/store', data)
}

// Edit academicYear
const academicYearEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/academic-year/edit/${id}`)
  return response.data
}

// Delete academicYear
const academicYearDelete = async (id: string) => {
  await axios.get(`/api/academic-year/destroy/${id}`)
}

// List programYear
const programYearList = async ({params}) => {
  const response = await axios.get('/api/program-year/list', params)
  return response.data
}

// Create Or Update new programYear
const programYearCreate = async ({data}) => {
  await axios.post('/api/program-year/store', data)
}

// Edit programYear
const programYearEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/program-year/edit/${id}`)
  return response.data
}

// Delete programYear
const programYearDelete = async (id: string) => {
  await axios.get(`/api/program-year/destroy/${id}`)
}

// List programLevel
const programLevelList = async ({params}) => {
  const response = await axios.get('/api/program-level/list', params)
  return response.data
}

// Create Or Update new programLevel
const programLevelCreate = async ({data}) => {
  await axios.post('/api/program-level/store', data)
}

// Edit programLevel
const programLevelEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/program-level/edit/${id}`)
  return response.data
}

// Delete programLevel
const programLevelDelete = async (id: string) => {
  await axios.get(`/api/program-level/destroy/${id}`)
}

// List semester
const semesterList = async ({params}) => {
  const response = await axios.get('/api/semester/list', params)
  return response.data
}

// Create Or Update new semester
const semesterCreate = async ({data}) => {
  await axios.post('/api/semester/store', data)
}

// Edit semester
const semesterEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/semester/edit/${id}`)
  return response.data
}

// Delete semester
const semesterDelete = async (id: string) => {
  await axios.get(`/api/semester/destroy/${id}`)
}

// List country
const countryList = async ({params}) => {
  const response = await axios.get('/api/country/list', params)
  return response.data
}

// Create Or Update new country
const countryCreate = async ({data}) => {
  await axios.post('/api/country/store', data)
}

// Edit country
const countryEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/country/edit/${id}`)
  return response.data
}

// Delete country
const countryDelete = async (id: string) => {
  await axios.get(`/api/country/destroy/${id}`)
}

// List videoCategory
const videoCategoryList = async ({params}) => {
  const response = await axios.get('/api/video-category/list', params)
  return response.data
}

// Create Or Update new videoCategory
const videoCategoryCreate = async ({data}) => {
  await axios.post('/api/video-category/store', data)
}

// Edit videoCategory
const videoCategoryEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/video-category/edit/${id}`)
  return response.data
}

// Delete videoCategory
const videoCategoryDelete = async (id: string) => {
  await axios.get(`/api/video-category/destroy/${id}`)
}

// List program
const programList = async ({params}) => {
  const response = await axios.get('/api/program/list', params)
  return response.data
}

// Create Or Update new program
const programCreate = async ({data}) => {
  await axios.post('/api/program/store', data)
}

// Edit program
const programEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/program/edit/${id}`)
  return response.data
}

const toolService = {
  sectionList,
  sectionCreate,
  sectionEdit,
  sectionDelete,
  academicYearList,
  academicYearCreate,
  academicYearEdit,
  academicYearDelete,
  programYearList,
  programYearCreate,
  programYearEdit,
  programYearDelete,
  programLevelList,
  programLevelCreate,
  programLevelEdit,
  programLevelDelete,
  semesterList,
  semesterCreate,
  semesterEdit,
  semesterDelete,
  countryList,
  countryCreate,
  countryEdit,
  countryDelete,
  videoCategoryList,
  videoCategoryCreate,
  videoCategoryEdit,
  videoCategoryDelete,
  programList,
  programCreate,
  programEdit,
}

export default toolService
